<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">QnA관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>제목</p>
                <input type="text" placeholder="제목을 입력하세요" class="form_control" v-model="searchInfo.title">
              </li>
              <li>
                <p>작성일자</p>
                <Datepicker v-model="searchInfo.startDate"  :defaultDate="searchInfo.startDate" /> 
                <span>~</span>
                <Datepicker v-model="searchInfo.endDate"  :defaultDate="searchInfo.endDate" /> 
              </li>            
              <li>
                <p>작성자</p>
                <input type="text" placeholder="작성자를 입력하세요" class="form_control" v-model="searchInfo.question_reg_nm">
              </li>  
              <li>
                <p>상태</p>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" checked value="" v-model="searchInfo.qna_status">
                  <label for="radio1">전체</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio" value="RQ" v-model="searchInfo.qna_status">
                  <label for="radio2">답변대기</label>
                </div>                
                <div class="form_radio">
                  <input type="radio" id="radio3" name="radio" value="RS" v-model="searchInfo.qna_status">
                  <label for="radio3">답변완료</label>
                </div>                                      
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <!-- <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue">신규 등록</button>
            </div>             -->
            <table class="list no_view">
              <thead>
                <tr>
                  <th>No</th>
                  <th>작성일자</th>
                  <th>제목</th>
                  <th>작성자</th>
                  <th>공개여부</th>
                  <th>처리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in qnaList" :key="index">
                  <td><span>{{ item.no ? item.no : index + 1 }}</span></td>
                  <td><span>{{ item.reg_dt }}</span></td>
                  <td class="al"><span>{{ item.qna_title }}</span></td>
                  <td><span>{{ item.doctor_nm }}</span></td>
                  <td><span>{{ item.scret_yn }}</span></td>
                  <td class="al">
                    <button v-show="item.qna_status === 'RQ'" :class="'bdge bd_blue '" @click="fn_move_reg_page(item)">답변대기</button>
                    <button v-show="item.qna_status === 'RS'" :class="'bdge bd_white'" @click="fn_move_reg_page(item)">답변완료</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_move_page" v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'  
  import Pagination from "@/components/AdminPagination.vue"
  //import { qnaList } from "../AdminData/BoardList"
  import Datepicker from '@/components/Datepicker.vue'
  import commonUtil from "@/mixin/commonUtil";


  export default {
    name: 'QnaMngt',
     mixins: [commonUtil],
    components: {
      Pagination,
      Datepicker
    },
    data() {
      return {
        searchInfo : {
          title : '',
          startDate : '',
          endDate : '',
          question_reg_id : '',
          question_reg_nm : '',
          qna_status : '',
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }                
        },
        pagingShow : false,
        qnaList: [],
      }
    },
    mounted(){
      //오늘 날짜구하기
      this.searchInfo.startDate =  this.getAddMonthDate(-1);
      this.searchInfo.endDate = this.getCurrentDate();
      this.fn_search();
    },
    methods : {
      fn_search(){
        console.log("@@@ search : %o",this.searchInfo);
        axios
            .post("/api/admin/board/getQnaList", this.searchInfo)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                this.qnaList = res.data.qnaList;

                console.log("@@@@ qnaList : %o",this.qnaList);

                this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                if(this.searchInfo.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                }                        

            })
            .catch((err) => console.log(err));
      },
      fn_move_page(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
      fn_move_reg_page(obj){
            this.$router.push({ name: 'QnaResponse', params: { id: obj.qna_seq } });
        },
    }
  }
</script>